function scrollToAnchorWithOffset(selector, offset = 22) {
  const element = document.querySelector(selector);
  if (!element) return;

  const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top, behavior: 'smooth' });
}

document.addEventListener('DOMContentLoaded', () => {
  const hash = window.location.hash;
  if (hash) {
    const anchorId = hash.slice(1);
    scrollToAnchorWithOffset(`[data-anchor-id="${anchorId}"]`);
  }
});
